"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimationWrapper = exports.Spinner = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.Spinner = styled_components_1.default.div `
  width: 240px;
  position: relative;
`;
exports.AnimationWrapper = styled_components_1.default.div `
  ${({ pending }) => (0, styled_components_1.css) `
    & > svg {
      width: 240px;
      height: 160px;
    }

    @keyframes rotate {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    @keyframes pulse {
      0% {
        fill: #162230;
      }
      30% {
        fill: #899bb5;
      }
      60% {
        fill: #162230;
      }
      100% {
        fill: #162230;
      }
    }

    ${pending &&
    (0, styled_components_1.css) `
      .shape {
        animation: rotate 4s linear infinite reverse;
      }

      .orbitOne {
        animation: rotate 2s linear infinite reverse;
      }

      .orbitTwo {
        animation: rotate 6s linear infinite reverse;
      }

      .pulse {
        animation: pulse 2s linear infinite;
      }

      .pulseOne {
        animation-delay: -1800ms;
      }
      .pulseTwo {
        animation-delay: -1600ms;
      }
      .pulseThree {
        animation-delay: -1400ms;
      }
      .pulseFour {
        animation-delay: -1200ms;
      }
      .pulseFive {
        animation-delay: -1000ms;
      }
      .pulseSix {
        animation-delay: -800ms;
      }
      .pulseSeven {
        animation-delay: -600ms;
      }
      .pulseEight {
        animation-delay: -400ms;
      }
      .pulseNine {
        animation-delay: -200ms;
      }
      .pulseTen {
        animation-delay: -0ms;
      }
    `}
  `}
`;
//# sourceMappingURL=styled.js.map